
const association_key = getURLParameter("key");
const booking_id = getURLParameter("booking_id");

$(document).ready(function () {

    const $errorAlert = $("#errorAlert");
    const $form = $("#videoLinkForm");
    const $meetingUrl = $("#meetingUrl");
    const $submitBtn = $("#submitBtn");
    const $successPanel = $("#successPanel");
    const $disclaimer = $("#disclaimer-box");

    // Only for VideoConference link review Page
    if (!$('#client_videoconference_review').length) return false;

    if (association_key === null || booking_id === null) {
        displayUnauthorizedPage();
        return;
    }
    
    // Retrieve related booking and check if all checksum validations are OK
    retrieveBookingForClient(booking_id, association_key);

    $form.on("submit", function(e) {
        e.preventDefault();
        clearError();

        const enteredUrl = $meetingUrl.val().trim();

        if (!enteredUrl) {
            showError("Please enter your videoconference meeting link");
            $meetingUrl.focus();
            return;
        }

        const urlPattern = /^(https?:\/\/)[^\s$.?#].[^\s]*$/i;
        if (!urlPattern.test(enteredUrl)) {
            showError("Please enter a valid URL starting with http:// or https://");
            $meetingUrl.focus();
            return;
        }

        const payload = {
            booking_id: booking_id,
            key: association_key,
            meetingUrl: enteredUrl
        };

        $.ajax({
            url: getApiURL("bookings/anonymous/review/client"),
            type: "POST",
            dataType: 'json',
            data: payload,
            beforeSend: function() {
                $submitBtn.prop("disabled", true).text("Saving Link...");
            },
            success: function () {
                $form.slideUp(300, function () {
                    $successPanel.fadeIn(300);
                });
            },
            error: function (request) {
                console.error("Submission failed", request);
                showError(ATLAlerts.formatAPIException(request));
            },
            complete: function() {
                $submitBtn.prop("disabled", false).text("Submit the link");
            }
        });
    })


    function retrieveBookingForClient(booking_id, association_key) {
        $.ajax({
            type: "GET",
            url: getApiURL("bookings/anonymous/review/client/") + booking_id + '/' + association_key,
            success: function (data) {
                $("[data-ref]").text(data.ref);
                $("[data-claim]").text(data.claim);
                $("[data-time]").text(moment(data.time).format("dddd DD/MM/YYYY [@] h:mm a"));
                if (data.already_confirmed) {
                    $disclaimer.show();
                    $("[data-link]").text(data.link);
                } else {
                    $form.show();
                }
                return data;
            },
            error: function (request) {
                switch (request.status) {
                    case 401: displayAlreadyReported(ATLAlerts.formatAPIException(request), "No Booking Available"); break;
                    case 404: displayNotFound(ATLAlerts.formatAPIException(request), "Booking Not Found"); break;
                    case 500: displayTechnical(); break;
                    default: displayUnauthorizedPage();
                }
                return null;
            }
        });
    }

    function showError(message) {
        $errorAlert.text(message).fadeIn(200);
    }
    function clearError() {
        $errorAlert.hide().text();
    }
});